import React from 'react';

const Searchbox = ({searchChange,route,searchHouse,searchByCharacters}) =>{
    if (route==='spell') {
        return(
            <div className = "Nav pa2 w-50">
                <input 
                    className="pa3 input-font big u-center-text ba b--green "
                    type= "search" 
                    placeholder = "search spells"
                    onChange={searchChange}
                />
            </div>
        );
    } else {
        if (searchByCharacters===true) {
            return(
                <div className = "Nav pa2 w-50">
                    <input 
                        className="pa3 input-font u-center-text ba b--green "
                        type= "search" 
                        placeholder = "search by name"
                        onChange={searchChange}
                    />
                </div>
            )
        } else {
            return(
                <div className = "Nav pa2 w-50">
                    <input 
                        className="pa3 input-font u-center-text ba b--green "
                        type= "search" 
                        placeholder = "search by house"
                        onChange={searchHouse}
                    />
                </div>
            )
        }
    }
}
export default Searchbox